export const NETWORK_API_ERROR_MESSAGE = "Network API Error,Please Check With Administrator";